import { render, staticRenderFns } from "./holidayList.vue?vue&type=template&id=0ec5abc4"
import script from "./holidayList.vue?vue&type=script&lang=js"
export * from "./holidayList.vue?vue&type=script&lang=js"
import style0 from "./holidayList.vue?vue&type=style&index=0&id=0ec5abc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports